<template>
  <div
      class="d-flex justify-content-end items-end fixed cursor-pointer position-fixed right-10 bottom-10"
      style="right: 10px; bottom: 10px;"
  >
    <div
        class="w-60px h-60px addButton"
        @click="onClick"
    >
      <i class="bx bx-plus bx-md"></i>
    </div>
  </div>
</template>

<script>
export default {
name: "AddButton",
  methods: {
  onClick() {
    this.$emit('onClick');
  }
  }
}
</script>

<style scoped>
.addButton {
  background-color: #5a8dee;
  border-radius: 50%;
  text-align: center;
  margin: 10px;
  z-index: 10000;
}
.addButton i {
  color: #fff;
  padding: 10px;
  font-size: 20px;
}

.right-10 {
  right: 1rem !important;
}

.bottom-10 {
  bottom: 3rem !important;
}
</style>
